
import { useSearchParams } from 'react-router-dom';

interface DebugInfoProps {
  buildVersion: string;
}

export const DebugInfo = ({ buildVersion }: DebugInfoProps) => {
  const [searchParams] = useSearchParams();

  return (
    <details className="mt-4 text-xs text-gray-500">
      <summary className="cursor-pointer font-medium">Informações de Debug (Expandir)</summary>
      <div className="mt-2 p-3 bg-gray-100 rounded text-xs font-mono space-y-1">
        <p><strong>URL Completa:</strong> {window.location.href}</p>
        <p><strong>Pathname:</strong> {window.location.pathname}</p>
        <p><strong>Search:</strong> {window.location.search}</p>
        <p><strong>Code:</strong> {searchParams.get('code') ? 'Presente' : 'Ausente'}</p>
        <p><strong>State:</strong> {searchParams.get('state') || 'Ausente'}</p>
        <p><strong>Store ID:</strong> {searchParams.get('store_id') || 'Ausente'}</p>
        <p><strong>Component Version:</strong> {buildVersion}</p>
        <p><strong>Timestamp:</strong> {new Date().toLocaleString()}</p>
      </div>
    </details>
  );
};
